import useModal from "./useModal";
import Modal from "./Modal";

export { useModal, Modal };
